module.exports = __webpack_public_path__ + "Icon_Sales.c30cc4ebdcabc8377a0b.png";